import React from 'react';
import Badge from '@mui/material/Badge';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import over from 'assets/img/over.svg';
import under from 'assets/img/under.svg';
import ideal from 'assets/img/ideal.svg';

import { NoAvailableCard } from 'common';
import { arrayOf, func, shape } from 'prop-types';
import { format, parseISO } from 'date-fns';
import * as R from 'ramda';
import { formatNumberWithoutDecimals } from 'utils/helpers/format';

const FutureProjections = ({ dailyProjections, setIsDrawerOpen, setSelectedDate }) => {
  return (
    <Stack sx={{ mt: 10 }}>
      <Typography variant="subtitle2">FUTURE PROJECTIONS</Typography>
      {!dailyProjections.length ? (
        <NoAvailableCard type="future projections" />
      ) : (
        <Box
          sx={{
            cursor: 'pointer',
            display: 'grid',
            gridAutoRows: 'auto',
            gridGap: '24px 16px',
            // eslint-disable-next-line sort-keys-fix/sort-keys-fix
            gridTemplateColumns: { xs: 'repeat(2, 158px)', lg: 'repeat(7, 158px)' },
            mt: 3,
            pb: 3,
          }}
        >
          {dailyProjections
            .slice(0, 14) // slicing to limit to 14 days for now
            .map(
              ({
                dailyProjectionDate,
                dailyProjectionStatus,
                dailyProjectionVolume,
                hasTransactions,
              }) => (
                <Box
                  data-testid="daily-projection"
                  key={dailyProjectionDate}
                  onClick={() => {
                    setIsDrawerOpen(true);
                    setSelectedDate(dailyProjectionDate);
                  }}
                  sx={{
                    boxShadow: 6,
                    display: 'flex',
                    flexDirection: 'column',
                    p: 1,
                  }}
                >
                  <Stack alignItems="center" direction="row" spacing={2} sx={{ mb: 2 }}>
                    <Badge
                      invisible={!hasTransactions}
                      sx={{
                        '& > .MuiBadge-dot': {
                          backgroundColor: 'success.dark',
                        },
                      }}
                      variant="dot"
                    >
                      <img
                        alt="projection indication"
                        src={
                          R.isNil(dailyProjectionStatus)
                            ? ideal
                            : R.equals('OVER MAX', dailyProjectionStatus)
                            ? over
                            : under
                        }
                      />
                    </Badge>
                    <Stack spacing={0.5}>
                      <Typography variant="subtitle2">
                        {format(parseISO(dailyProjectionDate), 'MM/dd/yy')}
                      </Typography>
                      <Typography color="text.primary" sx={{ fontWeight: 400 }} variant="caption">
                        {formatNumberWithoutDecimals(dailyProjectionVolume)} bbl
                      </Typography>
                    </Stack>
                  </Stack>
                  {R.not(R.isNil(dailyProjectionStatus)) && (
                    <Chip
                      label={dailyProjectionStatus}
                      sx={{ backgroundColor: 'error.light', color: 'error.dark', height: 20 }}
                    />
                  )}
                </Box>
              )
            )}
        </Box>
      )}
    </Stack>
  );
};

FutureProjections.propTypes = {
  dailyProjections: arrayOf(shape({})).isRequired,
  setIsDrawerOpen: func.isRequired,
  setSelectedDate: func.isRequired,
};

export default FutureProjections;
